
import Vue from "vue";

export default Vue.extend( {
  name: "ConfirmationDialog",
  props: {
    description: {
      default: "",
      type: String
    },
    title: {
      default: "",
      type: String
    },
    actionText: {
      default: "",
      type: String
    },
  },
  data() {
    return {
      dialog: false,
      deleteMandatory: true,
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    sendAction() {
      this.$emit("action", { mandatory: this.deleteMandatory });
      this.closeDialog();
    },
    closeDialog() {
      this.dialog = false;
    }
  }
})
